// Global payment modal state
class PaymentStore {
  constructor() {
    this.isOpen = false;
    this.paymentData = null;
    this.listeners = [];
  }

  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(cb => cb !== callback);
    };
  }

  openModal(data) {
    const nextSessionId = data?.session_id;
    const currentSessionId = this.paymentData?.session_id;

    if (
      this.isOpen &&
      nextSessionId &&
      currentSessionId &&
      nextSessionId === currentSessionId
    ) {
      return;
    }

    this.isOpen = true;
    this.paymentData = data;
    this.notifyListeners();
  }

  closeModal() {
    this.isOpen = false;
    this.paymentData = null;
    this.notifyListeners();
  }

  notifyListeners() {
    this.listeners.forEach(callback => {
      callback({ isOpen: this.isOpen, paymentData: this.paymentData });
    });
  }

  getState() {
    return { isOpen: this.isOpen, paymentData: this.paymentData };
  }
}

export const paymentStore = new PaymentStore();